import { render, staticRenderFns } from "./TaskRegister.vue?vue&type=template&id=35c47fab&"
import script from "./TaskRegister.vue?vue&type=script&lang=js&"
export * from "./TaskRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports